import React from 'react'
import { useCurrentSociety } from '../../../../hooks/useCurrentSociety'
import { Section, SectionList } from '../../../common/SectionList'
import { Checkbox } from '../../../common/Checkbox'
import { theme } from '../../../../theme/theme'
import { IUnitModel } from '../../../../interfaces/models/units.interfaces'
import { useSortedAssignedUnitsForSocietyPerAddress } from '../../RegisterUnitList'

export type UnitListItem = { unitId: string }

interface UnitListBaseProps {
  unitsList: UnitListItem[]
  setUnitsListValue: (val: UnitListItem[]) => void
}

interface UnitListItemProps extends UnitListBaseProps {
  unit: IUnitModel
  unitsList: UnitListItem[]
  setUnitsListValue: (val: UnitListItem[]) => void
  selected: boolean
}

export const UnitListItem = ({
  unit,
  unitsList,
  setUnitsListValue,
  selected,
}: UnitListItemProps): React.ReactNode => {
  const triggerSelect = (): void => {
    if (!selected) {
      setUnitsListValue([...unitsList, { unitId: unit._id }])
    } else {
      setUnitsListValue(unitsList.filter((_unit) => _unit.unitId !== unit._id))
    }
  }
  return (
    <div className="border-1 flex w-full items-center justify-between border-b py-4">
      <button onClick={triggerSelect}>
        <p style={theme.textVariants.base}>
          {unit.titleLegal} {unit.title ? `(${unit.title})` : ''}
        </p>
      </button>
      <Checkbox
        name={unit._id}
        value={selected}
        type="checkbox"
        onChange={triggerSelect}
      />
    </div>
  )
}

export const UnitListSection = ({
  unitsList,
  setUnitsListValue,
}: UnitListBaseProps): React.ReactNode => {
  const { society } = useCurrentSociety()

  const selectedUnitIdsMap = unitsList.reduce(
    (res: { [key: string]: boolean }, curr): { [key: string]: boolean } => {
      if (!(curr.unitId in res)) {
        res[curr.unitId] = true
      }
      return res
    },
    {}
  )
  const { addressesUnits } = useSortedAssignedUnitsForSocietyPerAddress(
    society?._id
  )

  const getSections = (): Section[] => {
    return (
      addressesUnits?.map((address) => ({
        title: address.address,
        item: (
          <div>
            {address.units.map((_unit) => (
              <UnitListItem
                key={_unit._id}
                unit={_unit}
                unitsList={unitsList}
                setUnitsListValue={setUnitsListValue}
                selected={selectedUnitIdsMap && _unit._id in selectedUnitIdsMap}
              />
            ))}
          </div>
        ),
      })) || []
    )
  }

  return (
    <SectionList sections={getSections()} className="flex flex-col gap-4" />
  )
}
